import React from "react";
import styles from "./styles.module.css";
import { ButtonProps } from "../types";
import { TextButton1 } from "fonts/Button1";
import { Spacing } from "spacing/component";

export const Button = ({ text, disabled, onClick, className }: ButtonProps) => (
  <button
    className={styles.component + (className ? ` ${className}` : "")}
    {...{ disabled, onClick }}
  >
    <Spacing ph="4xl" pv="s">
      <TextButton1 centered>{text}</TextButton1>
    </Spacing>
  </button>
);
